export default {
  en: {
    welcome: 'Welcome',
    orgDetails: 'Organisation details',
    leadUser: 'Lead user',
    agreements: 'Agreements',
    emailConfirm: 'Email confirmation',
    phoneAuth: 'Phone authentication',
    login: 'Login',
    forgotPassword: 'Forgot password',
    resetPassword: 'Reset password',
    smsMFA: 'SMS MFA',
    appMFA: 'App MFA',
    mfaSetup: 'Setup MFA',
  },
};
